const userLangKey = 'userLang'
export function getUserLang () {
  return window.localStorage.getItem(userLangKey) || 'zh-CN'
}
export function setUserLang (lang: string) {
  window.localStorage.setItem(userLangKey, lang)
}
